import React from 'react';

interface SyfoIconProps {
  className?: string;
  size?: number;
}

/**
 * Syfo application icon component
 * Displays the custom SVG icon for the Syfo brand
 */
export const SyfoIcon: React.FC<SyfoIconProps> = ({ 
  className = "", 
  size 
}) => {
  const sizeProps = size ? { width: size, height: size } : {};
  
  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient
          id="syfo-gradient-main"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4deab5" stopOpacity="1" />
          <stop offset="1" stopColor="#5fbcf5" stopOpacity="1" />
        </linearGradient>
        <linearGradient
          id="syfo-gradient-top"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.83333333,0,0,0.37499999,42.666669,71.999965)"
        >
          <stop offset="0" stopColor="#16bdd7" stopOpacity="1" />
          <stop offset="1" stopColor="#597cf0" stopOpacity="1" />
        </linearGradient>
        <linearGradient
          id="syfo-gradient-bottom"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.83333333,0,0,0.37499999,42.666669,248.00006)"
        >
          <stop offset="0" stopColor="#16bdd7" stopOpacity="1" />
          <stop offset="1" stopColor="#597cf0" stopOpacity="1" />
        </linearGradient>
      </defs>
      
      {/* Main background rectangle */}
      <rect
        fill="url(#syfo-gradient-main)"
        width="384"
        height="384"
        x="64"
        y="64"
        rx="64"
        ry="64"
      />
      
      {/* Top vault section */}
      <rect
        fill="url(#syfo-gradient-top)"
        width="320"
        height="144"
        x="96"
        y="96"
        rx="46.923073"
        ry="48"
      />
      
      {/* Bottom vault section */}
      <rect
        fill="url(#syfo-gradient-bottom)"
        width="320"
        height="144"
        x="96"
        y="272"
        rx="46.923073"
        ry="48"
      />
      
      {/* Vault legs/supports */}
      <path
        fill="#3a8edc"
        fillOpacity="1"
        d="M 128 448 L 128 475.94727 C 128 478.19276 129.68379 480 131.77539 480 L 176.22461 480 C 178.31621 480 179.21991 478.01326 180.09961 475.94727 L 192 448 L 128 448 z M 320 448 L 331.90039 475.94727 C 332.78009 478.01326 333.68379 480 335.77539 480 L 380.22461 480 C 382.31621 480 384 478.19276 384 475.94727 L 384 448 L 320 448 z"
      />
      
      {/* Top vault handle */}
      <path
        fill="#ffffff"
        d="m 197.5195,145.25975 v 35 A 10.482048,10.482048 0 0 0 208,190.74025 h 96 a 10.482048,10.482048 0 0 0 10.4805,-10.4805 v -35 h -20.961 v 24.5196 h -75.039 v -24.5196 z"
      />
      
      {/* Bottom vault handle */}
      <path
        fill="#ffffff"
        d="m 197.51953,321.25975 v 35 a 10.482048,10.482048 0 0 0 10.4805,10.4805 h 96 a 10.482048,10.482048 0 0 0 10.4805,-10.4805 v -35 h -20.961 v 24.5196 h -75.039 v -24.5196 z"
      />
    </svg>
  );
};

export default SyfoIcon;
